/**
 * BOTTOM GENERAL INITS
 * livecast
 */

import { InterviewQuestions } from "./interview-questions";
import { InterviewContact } from "./interview-contact";


export class InterviewInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        if ($('.question-list').length) {
            new InterviewQuestions();
        }

        if ($('.interview__contact-button').length) {
            new InterviewContact();
        }
    }
}
